module.exports = __webpack_public_path__ + "img/foot.9628e3f6.png";